import createVueApp from '@/common/createApp'
import sidebar from '@/config/sidebars/geobooster'

Styxie.Initializers.MobileWelcome = {
  about: async(props) => {
    const { default: AboutIndex } = await import('@/vue_widgets/geobooster/about/index.vue')
    createVueApp(AboutIndex, { props, sidebar })
  }
}
